var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 35,
    viewBox: "0 0 30 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_61_138",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 28,
    height: 33
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 1H1V34H29V1Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_61_138)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_61_138",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 28,
    height: 33
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29 1H1V34H29V1Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_61_138)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5 4H19.23C18.6 2.26 16.95 1 15 1C13.05 1 11.4 2.26 10.77 4H4.5C2.85 4 1.5 5.35 1.5 7V31C1.5 32.65 2.85 34 4.5 34H25.5C27.15 34 28.5 32.65 28.5 31V7C28.5 5.35 27.15 4 25.5 4ZM15 4C15.825 4 16.5 4.675 16.5 5.5C16.5 6.325 15.825 7 15 7C14.175 7 13.5 6.325 13.5 5.5C13.5 4.675 14.175 4 15 4ZM25.5 31H4.5V7H7.5V11.5H22.5V7H25.5V31Z",
    fill: "#FF573B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContent);
export default __webpack_public_path__ + "static/media/content.e6b770793ee42c2cee25db66697cd61a.svg";
export { ForwardRef as ReactComponent };